import { fetchCfgObjectIds } from "../utils/helpers";

import { JSX, useEffect, useState } from "react";

import { Alert, Box, MenuItem, Select } from "@mui/material";

export function CfgObjectSelect(): JSX.Element {
  const [cfgObjects, setCfgObjects] = useState<string[]>([]);

  useEffect(() => {
    async function getCfgObjectIds(): Promise<void> {
      const ids = await fetchCfgObjectIds();
      setCfgObjects(ids);
    }

    getCfgObjectIds();
  }, []);
  return (
    <Alert severity="error">
      <Box marginBottom={"0.75rem"}>
        No cfgObjectId set. Please set an cfgObject or select the cfgObject you
        were looking for. When including this application in an iFrame, check
        the url of the iFrame for the correct cfgObjectId.
      </Box>
      <Select
        defaultValue=""
        sx={{ minWidth: "300px", marginBlock: "0.5rem" }}
        onChange={(event) => {
          window.location.href = "/?cfgObjectId=" + event.target.value;
        }}
      >
        {cfgObjects?.map((cfgObject) => {
          return (
            <MenuItem value={cfgObject} key={cfgObject}>
              {cfgObject}
            </MenuItem>
          );
        })}
      </Select>
    </Alert>
  );
}
